<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="blue">
                        <v-toolbar-title class="my-0 py-0">CRONOGRAMA DE PLANIFICACIÓN DEL SGI (EI 007)
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codigogral }}
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4" class="py-0 my-0">
                    <v-card-text class="py-0 my-0">
                        <v-row dense>
                            <v-col cols="12" sm="12" md="6" align-self="stretch">
                                Cliente: {{ cliente }}
                            </v-col>
                            <v-col cols="12" sm="12" md="6" align-self="stretch">
                                Objetivo: {{ objetivo }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12" align-self="stretch">
                                Descripción: {{ descripcion }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="py-0 my-0">
                    <v-card-text class="py-0 my-0">
                        <!-- <v-btn class="mx-2" dark small color="primary" @click="addRow">Agregar fila</v-btn> -->
                        <table border="2" cellpadding="2" cellspacing="2" width="100%" id="AutoNumber2">
                            <thead>
                                <tr>
                                    <td width="26%" rowspan="2" colspan="2" bgcolor="#CCCCCC">
                                        <p align="center">
                                            <font face="Arial" color="black" size="2">Actividad</font>
                                        </p>
                                    </td>
                                    <td width="10%" rowspan="2" bgcolor="#CCCCCC">
                                        <p align="center">
                                            <font face="Arial" color="black" size="2">
                                                Responsable</font>
                                        </p>
                                    </td>
                                    <td width="48%" align="center" colspan="24" bgcolor="#CCCCCC">
                                        <font face="Arial" color="black" size="2">
                                            AÑO: {{ periodo }}
                                            <input type="text" name="anio" size="7"
                                                style="font-family: Arial; font-size: 10pt">
                                        </font>
                                    </td>
                                    <td width="5%" rowspan="2" bgcolor="#CCCCCC">
                                        <p align="center">
                                            <font face="Arial" color="black" size="2">Cumplimiento</font>
                                        </p>
                                    </td>
                                    <td width="20%" rowspan="2" bgcolor="#CCCCCC">
                                        <p align="center">
                                            <font face="Arial" color="black" size="2">Observaciones</font>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="4%" align="center" colspan="2" bgcolor="#FFCC99">
                                        <font color="black" face="Arial" size="2">Ene</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#99FFCC">
                                        <font color="black" face="Arial" size="2">Feb</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#FFFF99">
                                        <font color="black" face="Arial" size="2">Marz</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#CCCCFF">
                                        <font color="black" face="Arial" size="2">Abril</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#CCFF99">
                                        <font color="black" face="Arial" size="2">Mayo</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#FF99CC">
                                        <font color="black" face="Arial" size="2">Junio</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#FFCC99">
                                        <font color="black" face="Arial" size="2">Julio</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#99FFCC">
                                        <font color="black" face="Arial" size="2">Ago</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#FFFF99">
                                        <font color="black" face="Arial" size="2">Set</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#CCCCFF">
                                        <font color="black" face="Arial" size="2">Oct</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#CCFF99">
                                        <font color="black" face="Arial" size="2">Nov</font>
                                    </td>
                                    <td width="4%" align="center" colspan="2" bgcolor="#FF99CC">
                                        <font color="black" face="Arial" size="2">Dic</font>
                                    </td>
                                </tr>
                                <tr v-for="(tableData, index) in actividades" :id="index">
                                    <td width="26%" align="center" colspan="2" style="margin: 0 ">
                                        <font color="black" face="Arial" size="2"> {{ actividades[index].actividad }}
                                        </font>
                                    </td>
                                    <td width="10%" align="center" style="margin: 0">
                                        <font color="black" face="Arial" size="2"> {{ actividades[index].responsable }}
                                        </font>
                                    </td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].ene1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].ene2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].feb1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].feb2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].mar1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].mar2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].abr1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].abr2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].may1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].may2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].jun1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].jun2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].jul1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].jul2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].ago1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].ago2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].sep1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].sep2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].oct1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].oct2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].nov1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].nov2)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].dic1)"
                                        style="margin: 0"></td>
                                    <td width="2%" align="center" :class="bgcolor = colorfondo(actividades[index].dic2)"
                                        style="margin: 0"></td>
                                    <td width="5%" align="center" style="margin: 0">
                                        <font color="black" face="Arial" size="2"> {{ actividades[index].valor }} %
                                        </font>
                                    </td>
                                    <td width="20%" align="center" style="margin: 0">
                                        <!-- <div class="multi-line"> -->
                                        <font color="black" face="Arial" size="1">{{ actividades[index].observ }}</font>
                                        <!-- </div> -->
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    </v-card-text>
                </v-card>



                <v-card>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="4" md="4">
                                Elaboró: {{ elaboro }}
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                Fecha: {{ fecha }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="3">
                                Observaciones: {{ observ }}
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                Estado: {{ estado }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-if="fileInfos.length > 0" class="mx-auto">
                    <v-list>
                        <v-subheader>Lista de archivos</v-subheader>
                        <v-list-item-group color="primary">
                            <v-list-item v-for="(file, index) in fileInfos" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title class="mb-3">

                                        <a target="_blank" :href="'https://api.icssa.com.ar/informes/' + file.descripcion
                                            ">{{ file.titulo }}</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-form>
        </v-app>
    </div>

</template>
<style scoped>
.multi-line {
    white-space: pre-line;
}
</style>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import readXlsFile from "read-excel-file";
export default {
    data: (vm) => ({

        codigogral: "",
        area: "",
        codarea: "",
        revision: "",
        cliente: "",
        objetivo: "",
        descripcion: "",
        periodo: "",
        elaboro: "",
        fecha: "",
        estado: "",
        observ: "",
        promedio: "",
        fileInfos: "",
        actividades: [],
        headers: [
            { text: "Actividad", value: "actividad", sortable: false },
            { text: "Responsable", value: "responsable", sortable: false },
            { text: "Enero", value: "ene1", sortable: false },
            { text: "Enero", value: "ene2", sortable: false },
            { text: "Febrero", value: "feb1", sortable: false },
            { text: "Febrero", value: "feb2", sortable: false },
            { text: "Marzo", value: "mar1", sortable: false },
            { text: "Marzo", value: "mar2", sortable: false },
            { text: "Abril", value: "abr1", sortable: false },
            { text: "Abril", value: "abr2", sortable: false },
            { text: "Mayo", value: "may1", sortable: false },
            { text: "Mayo", value: "may2", sortable: false },
            { text: "Junio", value: "jun1", sortable: false },
            { text: "Junio", value: "jun2", sortable: false },
            { text: "Julio", value: "jul1", sortable: false },
            { text: "Julio", value: "jul2", sortable: false },
            { text: "Agosto", value: "ago1", sortable: false },
            { text: "Agosto", value: "ago2", sortable: false },
            { text: "Septiembre", value: "sep1", sortable: false },
            { text: "Septiembre", value: "sep2", sortable: false },
            { text: "Octubre", value: "oct1", sortable: false },
            { text: "Octubre", value: "oct2", sortable: false },
            { text: "Noviembre", value: "nov1", sortable: false },
            { text: "Noviembre", value: "nov2", sortable: false },
            { text: "Diciembre", value: "dic1", sortable: false },
            { text: "Diciembre", value: "dic2", sortable: false },
            { text: "Cumplimiento", value: "valor", sortable: false },


        ]

    }),

    computed: {
        show: {
            get() {
                //     if (this.codgral != null && this.codgral != "") {
                //         this.cargar();
                //     }
                //     return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        colorfondo(condicion) {
            if (condicion == "ON")
                return "black";
        },
        cargar() {

            const codgral = this.codgral;
            const area = this.area;
            const codarea = this.codarea;
            let self = this;
            if (this.codgral != null && this.codgral != "") {
                axios
                    .get("/App/CargarPlanes?", {
                        params: {
                            codgral: codgral,
                        },
                    })
                    .then((response) => {

                        //self.id = response.data.id;
                        //self.codgral = response.data.codgral;
                        self.area = response.data.area;
                        self.codarea = response.data.codarea;
                        self.codigogral = self.area + "-" + self.codarea;
                        self.revision = response.data.revision;
                        self.cliente = response.data.cliente;
                        self.objetivo = response.data.objetivo;
                        self.fecha = response.data.fecha;
                        self.descripcion = response.data.descripcion;
                        self.periodo = response.data.periodo;
                        self.elaboro = response.data.elaboro;
                        self.promedio = response.data.promedio;
                        self.estado = response.data.estado;
                        //self.fileInfos = response.data.informes;
                        self.actividades = response.data.actividades;


                        if (self.estado == "P") {
                            self.estado = "Pendiente"
                        }
                        else {
                            self.estado = "Cerrado"
                        }
                    })
                    .catch((error) => {
                        //self.nomcodigo = [];
                        console.log(error);
                    });
            }
            else {
                axios
                    .get("/App/CargarPlaneslink?", {
                        params: {
                            area: area,
                            codarea: codarea,
                        },
                    })
                    .then((response) => {

                        //self.id = response.data.id;
                        //self.codgral = response.data.codgral;
                        self.area = response.data.area;
                        self.codarea = response.data.codarea;
                        self.codigogral = self.area + "-" + self.codarea;
                        self.revision = response.data.revision;
                        self.cliente = response.data.cliente;
                        self.objetivo = response.data.objetivo;
                        self.fecha = response.data.fecha;
                        self.descripcion = response.data.descripcion;
                        self.periodo = response.data.periodo;
                        self.elaboro = response.data.elaboro;
                        self.promedio = response.data.promedio;
                        self.estado = response.data.estado;
                        //self.fileInfos = response.data.informes;
                        self.actividades = response.data.actividades;


                        if (self.estado == "P") {
                            self.estado = "Pendiente"
                        }
                        else {
                            self.estado = "Cerrado"
                        }
                    })
                    .catch((error) => {
                        //self.nomcodigo = [];
                        console.log(error);
                    });
            }
        },


        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
        },

        vaciarModels() {
            this.codigogral = "";
            this.area = "";
            this.codarea = "";
            this.revision = "";
            this.cliente = "";
            this.objetivo = "";
            this.descripcion = "";
            this.periodo = "";
            this.elaboro = "";
            this.fecha = "";
            this.estado = "";
            this.promedio = "";
            this.fileInfos = [];
            this.actividades = [];

        },


    },

    beforeMount() {
        this.codgral = this.$route.query.codgral;
        this.area = this.$route.query.area;
        this.codarea = this.$route.query.codarea;
        this.cargar();

        return this.visible;
    },
};
</script>